import { render, staticRenderFns } from "./middle3.vue?vue&type=template&id=0a9797f8&scoped=true&"
import script from "./middle3.vue?vue&type=script&lang=js&"
export * from "./middle3.vue?vue&type=script&lang=js&"
import style0 from "./middle3.vue?vue&type=style&index=0&id=0a9797f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9797f8",
  null
  
)

export default component.exports